import React from 'react'
import { ModuleHeader } from '../../module-header'
import { StyledSubjectListGrid } from './subject-list.style'
import SubjectListItem from './subject-list-item'


const SubjectList = () => {
    return (
        <>
            <ModuleHeader title="SUBJECT LIST" />
            <StyledSubjectListGrid>
                <SubjectListItem subjectTitle="Mathematics" subjectTerm="1" numberOfTopics="12" />
                <SubjectListItem subjectTitle="English" subjectTerm="1" numberOfTopics="7" />
                <SubjectListItem subjectTitle="Chemistry" subjectTerm="1" numberOfTopics="15" />
                <SubjectListItem subjectTitle="Physics" subjectTerm="1" numberOfTopics="10" />
                <SubjectListItem subjectTitle="Biology" subjectTerm="1" numberOfTopics="17" />
                <SubjectListItem subjectTitle="Computer Science" subjectTerm="1" numberOfTopics="5" />
            </StyledSubjectListGrid>
        </>
    )
}

export { SubjectList }
